import { ReactNode } from 'react';
import { DatesProvider as MantineDatesProvider } from '@mantine/dates';
import { useContent } from './ContentProvider';
import 'dayjs/locale/pl';

export const DatesProvider = ({ children }: { children: ReactNode }) => {
	const { language } = useContent();

	return (
		<MantineDatesProvider
			settings={{
				locale: language.toLowerCase(),
				firstDayOfWeek: 1,
				weekendDays: [0],
			}}
		>
			{children}
		</MantineDatesProvider>
	);
};
